/* eslint-disable no-param-reassign */
import { ISource, PlayerBase } from '@24i/player-base';
import { Asset, isBroadcast, isChannel, Stream } from '@24i/nxg-sdk-photon';
import { ISeriesData } from '@24i/nxg-sdk-smartott-shared/src/types';
import { isCompatibleSource } from '@24i/player-utils-react';

export interface PlaybackState {
    source?: ISource;
    stream?: Stream | null;
    asset?: Asset | null;
    seriesData?: ISeriesData | undefined;
    hasAccurateTimes?: boolean;
    currentTime?: number;
    duration?: number;
    live?: boolean;
    lastMilestone?: number;
}

export const updatePlaybackState = (
    target: PlaybackState | undefined,
    playerInstance: PlayerBase | undefined
): void => {
    if (!target) return;
    const { source, asset } = target;
    if (
        playerInstance &&
        isCompatibleSource(playerInstance.source, source) &&
        playerInstance.isMetadataLoaded() &&
        Number.isFinite(playerInstance.duration)
    ) {
        target.hasAccurateTimes = true;
        target.live = playerInstance.live;
        target.currentTime = playerInstance.currentTime;
        target.duration = playerInstance.duration;
        if (playerInstance.ended && playerInstance?.currentAd === null) {
            target.currentTime = playerInstance.duration;
        }
    } else if (asset && !target.hasAccurateTimes) {
        target.live = isBroadcast(asset) || isChannel(asset);
        target.currentTime = (asset.continueWatchingOffset || 0) * 1000;
        target.duration = (asset.duration || 0) * 1000;
    }
};
